import { useModules } from '@/modules';
import { Card } from '@dreamtree-org/twreact-ui';
import { useAuth } from '@rbac/useCan';
import { isRetiredModule } from '@/lib/tenantAuth';
import PageShell from '@/components/layout/PageShell';
import PageHeader from '@/components/layout/PageHeader';

export default function Dashboard() {
  const user = useAuth();
  const { modules } = useModules();
  const mods = Object.values(modules).filter((m) => !isRetiredModule(m.key));
  return (
    <PageShell className="space-y-4">
      <PageHeader
        title={<>Welcome{user && user.name ? `, ${user.name}` : ''}</>}
        subtitle={(
          <>
            {user && user.isAdmin ? 'Tenant admin' : 'Member'} · {(user && user.permissions && user.permissions.length) || 0} permissions
          </>
        )}
      />
      <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {mods.map((m) => (
          <Card key={m.key} hover className="p-4">
            <div className="font-semibold">{m.label}</div>
            <div className="text-sm text-secondary-500">{(m.models || []).join(', ') || '—'}</div>
          </Card>
        ))}
      </div>
    </PageShell>
  );
}
